import logo from './logo.svg';
import './App.css';
import Temp from './Temp';


function App() {
  return (
    <div className="App">
     <Temp/>
    </div>
  );
}

export default App;
